import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;

export function getSocketInstance(): Socket {
  if (!socket) {
    socket = io(`${process.env.REACT_APP_DIRECTSEARCH_BACKEND_URI}/search`, {
      autoConnect: false,
    });
  }
  return socket;
}
